export default __webpack_public_path__ + "static/media/falcon_join_1.e2a96aae.svg";